import { defineStore } from 'pinia'
import type { WishlistAddRequest, WishlistAddResponse } from '~/types/on24-klient'

type View = 'login' | 'register'

type WishlistQueuedItem = {
  productId: number
  variationId: number | null
  optionIds: number[] | null
} | null

export const useLoginModalStore = defineStore('loginModal', () => {
  const isOpen = ref(false)
  const currentView = ref<View>('login')
  const text = ref('')
  const queuedWishlistItem = ref<WishlistQueuedItem>(null)

  const open = (content: string | null, view: View = 'login') => {
    isOpen.value = true
    text.value = content ?? text.value
    currentView.value = view
  }

  const close = () => {
    isOpen.value = false
    queuedWishlistItem.value = null
  }

  const setIsOpen = (value: boolean) => {
    isOpen.value = value

    if (!value) {
      queuedWishlistItem.value = null
    }
  }

  const setCurrentView = (value: View) => {
    currentView.value = value
  }

  const setQueuedWishlistItem = (productId: number, variationId: number | null, optionIds: number[] | null) => {
    queuedWishlistItem.value = {
      productId,
      variationId,
      optionIds,
    }
  }

  const useQueuedWishlistItem = () => {
    if (queuedWishlistItem.value) {
      $fetch<WishlistAddResponse>('/api/account/wishlist/add', {
        method: 'POST',
        body: {
          productId: queuedWishlistItem.value.productId,
          variationId: queuedWishlistItem.value.variationId,
          optionIds: queuedWishlistItem.value.optionIds,
        } satisfies WishlistAddRequest,
      })

      queuedWishlistItem.value = null
    }
  }

  return {
    isOpen,
    currentView,
    text,
    queuedWishlistItem,
    open,
    close,
    setIsOpen,
    setCurrentView,
    setQueuedWishlistItem,
    useQueuedWishlistItem,
  }
})
